import Vuex from 'vuex'
import Vue from 'vue'
import authentication from 'modules/authentication'
import user from 'modules/user'
import localization from 'modules/localization'
import configurations from 'modules/configurations'
import dashboard from 'modules/dashboard'
import tags from 'modules/tags'
import sequence from 'modules/sequence'

// Load Vuex
Vue.use(Vuex)

// Create store
export default new Vuex.Store({
	modules: {
		authentication,
		user,
		localization,
		configurations,
		dashboard,
		tags,
		sequence
	}
})
